import { MouseEventHandler, useState } from 'react'
import { ChevronLeft } from 'react-feather'
import { NumberFmt } from 'src/utils'
import { formatDate } from 'src/utils/formatDate'
import { AdjustmentDetails } from '../../StockAdjustmentInBatchTypes'
import CancelModalAdjustments from '../CancelModalAdjustments'
import ConfirmModalAdjustments from '../ConfirmModalAdjustments'
import * as S from './PendingAdjustmentDetailsHeader.styles'
import { Typography } from '@mui/material'
import PendingAdjustmentSelect from '../PendingAdjustmentSelect/PendingAdjustmentSelect'

interface FieldProps {
  label: string
  value: any
}

const Field = ({ label, value }: FieldProps) => (
  <S.Label>
    {label}<S.Text title={value}>{value}</S.Text>
  </S.Label>
)

const FieldNumerical = ({ label, value }: FieldProps) => (
  <S.Label style={{ justifyContent: 'space-between' }}>
    {label}<S.Text title={value}>{NumberFmt({ value, sufix: '' })}</S.Text>
  </S.Label>
)

interface Props {
  handleClickBackButton?: MouseEventHandler<HTMLButtonElement>
  pendingAdjustment: Omit<AdjustmentDetails, 'items'>
  adjustmentId: number
}

export default ({
  handleClickBackButton,
  pendingAdjustment,
  adjustmentId,
}: Props) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)

  const [decision, setDecision] = useState<string>()
  const [selectError, setSelectError] = useState(false)

  const confirmButton = () => {
    if (!decision) {
      setSelectError(true)
      return
    }
    setSelectError(false)
    setShowConfirmModal(true)
  }

  return (
    <>
      <S.WrapperSection>
        <S.Section>
          <S.BackButton
            onClick={handleClickBackButton}
            bgColor='darkBlue'
            hoverColor='darkBlueHover'
            letterColor='white'
            title={(
              <>
                <ChevronLeft viewBox='0 0 24 28'/>
                Voltar
              </>
          )}
          />
        </S.Section>
        <S.Section>
          <Typography variant='h5' fontWeight='bold' textAlign='end'>Detalhes de ajustes</Typography>
        </S.Section>
      </S.WrapperSection>
      <S.WrapperSection>
        <S.Section style={{ flex: 3.5 }}>
          <Field label='Usuário: ' value={pendingAdjustment.user} />
          <Field label='Data da requisição: ' value={formatDate(pendingAdjustment.createdAt as Date)} />
          <Field label='Estoque a ser ajustado: ' value='' />
        </S.Section>
        <S.Section style={{ flex: 1 }}>
          <FieldNumerical label='Total de Ajustes' value={pendingAdjustment.totalAdjustments} />
        </S.Section>
      </S.WrapperSection>
      <S.ButtonSection>
        <PendingAdjustmentSelect
          setDecision={setDecision}
          setSelectError={setSelectError}
          selectError={selectError}
          decision={decision}
        />
        <S.ActionButton
          onClick={confirmButton}
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          title='Aceitar todos'
        />
        <S.ActionButton
          onClick={() => setShowCancelModal(true)}
          bgColor='cancel'
          hoverColor='cancelHover'
          letterColor='white'
          title='Cancelar todos'
        />
      </S.ButtonSection>
      <ConfirmModalAdjustments
        adjustmentId={adjustmentId}
        showModal={showConfirmModal}
        setShowModal={setShowConfirmModal}
        totalAdjustments={pendingAdjustment.totalAdjustments}
        decision={decision}
      />
      <CancelModalAdjustments
        adjustmentId={adjustmentId}
        showModal={showCancelModal}
        setShowModal={setShowCancelModal}
        totalAdjustments={pendingAdjustment.totalAdjustments}
      />
    </>
  )
}
